import axios from 'axios'
import { attachRefreshInterceptor } from '@racefront/common'
import { REFRESH_TOKEN } from '../constants/endpoints'
import { useAuthStore } from '../app/data/stores/auth.store'

const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  withCredentials: true,
})

api.interceptors.request.use((config) => {
  const { session } = useAuthStore.getState()
  if (session?.idToken && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${session.idToken}`
  }
  return config
})

attachRefreshInterceptor(api, {
  shouldRefresh: (error) => error.response?.status === 401 && error.config?.url !== REFRESH_TOKEN,
  refresh: async () => {
    const { session, loadSession } = useAuthStore.getState()
    await api.post(REFRESH_TOKEN, {
      refreshToken: session?.refreshToken,
      username: session?.idTokenDecoded?.['cognito:username'],
    })
    loadSession()
  },
  applyAuthHeader: (config) => {
    config.headers['Authorization'] = `Bearer ${useAuthStore.getState().session?.idToken}`
    return config
  },
  onRefreshFailure: () => {
    useAuthStore.getState().resetSession()
  },
})

export default api
